import $ from 'jquery';
import Tab from '@/js/plugins/Tab';
import 'slick-carousel';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import CountAction from "@/js/plugins/CountAction";
import { countUpAction } from "@/js/helpers";
import { parentChildCheckbox } from '@/js/components/others/_search-list';

// ヘッダーの表示制御
const setHeaderAction = () => {
    const headerObj = document.querySelector('.l-header');
    const headerObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                // 領域内に入ったときの処理
                headerObj.dataset.position = 'hero';
            } else {
                // 領域外に出たときの処理
                delete headerObj.dataset.position;
            }
        })
    });

    headerObserver.observe(document.querySelector(".p-hero"));
}

// heroスライダーアクション
const heroSliderAction = () => {
    const slider = $(".js-hero-slider");
    slider.slick({
        autoplay: true,
        arrows: false,
        fade: true,
        speed: 2000,
        autoplaySpeed: 3000,
    })
}


// pickupスライダーアクション
const pickupSliderAction = () => {
    const pickupSlider = $(".js-pickup-slider .p-pickup-images-main");
    pickupSlider
        .slick()
        .on('afterChange', (event, slick, currentSlide) => {
            changeSlide(currentSlide);
        });
    const changeSlide = (index) => {
        $('.p-pickup-images__pagination a').each((i, el) => {
            el.classList.remove('is-active');
        });
        $(`.p-pickup-images__pagination a[data-index="${index}"]`).addClass('is-active');
    }

    $('.p-pickup-images__items img').on('click', (e) => {
        const index = e.currentTarget.dataset.index;
        pickupSlider.slick('slickGoTo', index);
        changeSlide(index);
    });
    $('.p-pickup-images__pagination a').on('click', (e) => {
        const index = e.currentTarget.dataset.index;
        pickupSlider.slick('slickGoTo', index);
        changeSlide(index);
    });
}

const areaSearchNewUsedChange = (areaSearchItems) => {
    document.querySelectorAll('input[name="newly-used-house"]').forEach((obj) => {
        obj.addEventListener('change', (e) => {
            const value = e.currentTarget.value;
            document.querySelectorAll('.p-area-search-tabs__item[data-type="house"] .c-others-search-list[data-mode]').forEach((obj) => {
                delete obj.dataset.open;
            });
            document.querySelector(`.p-area-search-tabs__item[data-type="house"] .c-others-search-list[data-mode=${value}]`).dataset.open = '';
            document.querySelector('.p-area-search__submit .c-buttons-submit').setAttribute('form', `area-search-form-${value}`);

            areaSearchItems[value].countAction.count();
        });
    });
}

const areaSearchCountAction = () => {
    const areaSearchItems = {}
    document.querySelectorAll('.p-area-search .c-others-search-list').forEach((obj) => {
        const mode = obj.dataset.mode;
        const countAction = new CountAction(obj);
        areaSearchItems[mode] = { countAction }
        countAction.on('countChange', (e) => {
            const countTarget = document.querySelector('[data-pickup-count]');
            countUpAction(countTarget, e.count);
            if (e.count == 0) {
                document.querySelector('.p-area-search-result').dataset.empty = '';
                document.querySelector('.p-area-search .c-buttons-submit').setAttribute('disabled', '');
            } else {
                delete document.querySelector('.p-area-search-result').dataset.empty;
                document.querySelector('.p-area-search .c-buttons-submit').removeAttribute('disabled');
            }
        });
    })
    return areaSearchItems;
}

// エリア検索のアクション設定
const areaSearchLoad = () => {
    document.querySelector('.p-area-search').addEventListener('onLoadContents', () => {
        const areaSearchItems = areaSearchCountAction();
        areaSearchNewUsedChange(areaSearchItems);
        parentChildCheckbox();
        const tab = new Tab('area-search-tabs');
        tab.init();
        tab.on('tagChange', (e) => {
            let type = document.querySelectorAll('.p-area-search-tabs__item')[e.currentPage].dataset.type;
            if (type == 'house') {
                type = document.querySelector(`.p-area-search-tabs__item[data-type="house"] .c-others-search-list[data-open]`).dataset.mode;
            }
            document.querySelector('.p-area-search__submit .c-buttons-submit').setAttribute('form', `area-search-form-${type}`);
            areaSearchItems[type].countAction.count();
        });
    });
}

const staffSliderAction = () => {
    const staffSlider = $(".js-staff-slider");
     $(staffSlider).slick({
         slidesToShow: 2,
         arrows: true,
         prevArrow: '<button class="p-staff__prev-arrow"></button>',
         nextArrow: '<button class="p-staff__next-arrow"></button>',
         infinite: false,
         autoplaySpeed: 3000,
         variableWidth: true,
         responsive: [
             {
                 breakpoint: 640,
                 settings: {
                     slidesToShow: 1,
                     centerMode: true,
                     infinite: true,
                     variableWidth: false,
                 },
             },
         ],
     });

}

const main = () => {
    if (document.querySelector('#page-home') === null) return;
    document.querySelector('.l-header').dataset.position = 'hero';

    document.querySelector('.p-hero__search button').addEventListener('click', () => {
        document.querySelector('.p-hero-search-modal').dataset.open = '';
    });
    document.querySelector('.p-hero-search-modal .c-buttons-close').addEventListener('click', () => {
        delete document.querySelector('.p-hero-search-modal').dataset.open;
    });

    /*
    document.querySelector('.p-fixed-line-campaign .p-fixed-line-campaign__close').addEventListener('click', () => {
        document.querySelector('.p-fixed-line-campaign').dataset.close = '';
    });
    */

    setHeaderAction();
    pickupSliderAction();
    areaSearchLoad();
    heroSliderAction();
    staffSliderAction();
}

export default main;
